import styled from 'styled-components';

import { TColors, TSpacing, TTypography } from './types';

import { customMarginStyles, customPaddingStyles } from '../../../styles/Shared/SharedStyles';
import { handleTypography } from '../../../styles/Shared/TypographyStyles';
import { CSSProperties } from 'react';

export const Paragraph = styled('p')<TSpacing & TTypography & TColors & CSSProperties>`
    ${customMarginStyles}
    ${customPaddingStyles}
    color: ${({ color, customColor, theme }) => {
        if (customColor) return theme.color[customColor];
        return color;
    }};
    text-align: ${({textAlign}) => textAlign ? textAlign : null};
    ${(props: TTypography) => handleTypography(props)};
`;